"use client";

import React from "react";
import { SpacingType, sectionVariants, ButtonStyleType } from "@/types";
import { SectionWrapper } from "../components/SectionWraper";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import parse from "html-react-parser";

interface Hero11Props {
  darkMode?: boolean;
  spacing?: SpacingType;
  variant?: sectionVariants;
  contents?: {
    badge?: string;
    title?: string;
    content?: string;
    microCopy?: string;
    hasButton?: boolean;
    buttonText?: string;
    buttonLink?: string;
    buttonStyle?: ButtonStyleType;
    secondaryButton?: boolean;
    secondaryButtonText?: string;
    secondaryButtonLink?: string;
    secondaryButtonStyle?: ButtonStyleType;
  };
  attributes?: React.HTMLProps<HTMLElement>;
}

const Hero11 = ({
  darkMode = false,
  spacing,
  variant = 'A',
  contents,
  attributes,
}: Hero11Props) => {


  return (
    <SectionWrapper 
      spacing={spacing}
      variant={variant}
      darkMode={darkMode}
      heroSection={true}
      componentName="hero11"
      attributes={attributes}
      usedInPageNav={false}
      pageNavTitle="Hero 11"
    >     
      <div className="container"> 
        <div className="flex flex-col xl:flex-row gap-x-20 items-center">
          <div className="w-full xl:w-[50%] text-center xl:text-left">
            {contents?.badge && (
              <Badge variant="outline" bold className="mb-6">
                {contents?.badge}
              </Badge>
            )}
            {contents?.title && (
              <>
              <h1 className="mb-8">
                {parse(contents.title)}
              </h1>
              </>
            )}
          </div>
          <div className="w-full xl:w-[50%] text-center xl:text-left">
            {contents?.content && (
              <div className="paragraph-lg mx-auto !font-normal">
                {parse(contents?.content)}
              </div>
            )}
            {contents?.hasButton && (
              <div className="mt-8 flex flex-col">
                <div className="flex flex-col gap-2 sm:flex-row justify-center xl:justify-start">
                  <Button 
                    size="lg" 
                    variant={contents?.buttonStyle || "primary"}
                    className="w-full gap-2 sm:w-auto"
                    asChild
                  >
                    <a href={contents?.buttonLink}>
                      {contents?.buttonText}
                    </a>
                  </Button>
                  {contents?.secondaryButton && (
                    <Button
                      variant={contents?.secondaryButtonStyle || "outline"}
                      size="lg"
                      className="w-full gap-2 sm:w-auto"
                      asChild
                    >
                      <a href={contents?.secondaryButtonLink}>
                        {contents?.secondaryButtonText}
                      </a>
                    </Button>
                  )}
                </div>
                {contents?.microCopy && (
                  <p className="paragraph-sm text-muted-foreground text-center xl:text-left mt-3">
                    {contents?.microCopy}
                  </p>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </SectionWrapper>
  );
};

export { Hero11 };
